import { Checkbox } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import { Typography } from "@aviary";
import type { Filter } from "@shared/components/CatalogSearch/CatalogSearch";
import { l } from "@shared/locales/i18n";
import type * as Types from "@shared/types/graphqlGenerated";

import * as styles from "./SuggestedCertifications.styles";

type Certification = Pick<
  Types.ThirdPartyCertificationContextualFilters,
  "id" | "esResultCount"
> & {
  thirdPartyCertification: Pick<Types.ThirdPartyCertification, "id" | "name">;
};

interface Props {
  certifications: Certification[];
  handleCertificationSelect: (certificationSelected: Filter) => void;
  isCertificationActive: (id: string) => boolean;
  renderCertificationLabel: (certificationWithCount: Certification) => string;
}
const SuggestedCertifications = ({
  certifications,
  handleCertificationSelect,
  isCertificationActive,
  renderCertificationLabel,
}: Props) => {
  const { t } = useTranslation();

  const renderSuggestedCertifications = () =>
    certifications?.map(certificationWithCount => {
      return (
        <span key={certificationWithCount.thirdPartyCertification.id} css={styles.checkbox}>
          <Checkbox
            isFullWidth
            checked={isCertificationActive(certificationWithCount.thirdPartyCertification.id)}
            onChange={() =>
              handleCertificationSelect({
                name: certificationWithCount.thirdPartyCertification.name,
                id: certificationWithCount.thirdPartyCertification.id,
                category: "Certifications",
              })
            }
          >
            {renderCertificationLabel(certificationWithCount)}
          </Checkbox>
        </span>
      );
    });

  return (
    <>
      <Typography type="h5">{t(l.sharedCatalog.filter.SuggestedCertifications)}</Typography>
      {renderSuggestedCertifications()}
    </>
  );
};

export { SuggestedCertifications };
